import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/i18n";
import { Shell } from "@/components/Shell";
import { toast } from "sonner";
import { CheckCircle, CalendarBlank, Phone, MapPin } from "@phosphor-icons/react";

const TABS = [
  { key: "due_today", color: "text-amber-600" },
  { key: "upcoming", color: "text-blue-600" },
  { key: "overdue", color: "text-red-600" },
  { key: "completed", color: "text-emerald-600" },
];

export default function FollowUps() {
  const { t } = useLang();
  const [data, setData] = useState({ due_today: [], upcoming: [], overdue: [], completed: [] });
  const [tab, setTab] = useState("due_today");

  const load = () => api.get("/followups").then(({ data }) => setData(data));
  useEffect(() => { load(); }, []);

  const complete = async (id) => { await api.post(`/followups/${id}/complete`); toast.success(t("completed")); load(); };
  const reschedule = async (id) => {
    const d = prompt("New date (YYYY-MM-DD)");
    if (d) { await api.post(`/followups/${id}/reschedule`, { due_date: d }); load(); }
  };

  return (
    <Shell title={t("followups")}>
      <div className="flex gap-2 overflow-x-auto no-scrollbar mb-4">
        {TABS.map((tb) => (
          <button
            key={tb.key}
            data-testid={`fu-tab-${tb.key}`}
            onClick={() => setTab(tb.key)}
            className={`px-4 min-h-[40px] rounded-lg text-sm font-semibold whitespace-nowrap border ${tab === tb.key ? "bg-slate-800 text-white border-slate-800" : "bg-white border-slate-200 text-slate-600"}`}
          >
            {t(tb.key)} ({data[tb.key]?.length || 0})
          </button>
        ))}
      </div>
      <div className="space-y-3">
        {(data[tab] || []).map((f) => (
          <div key={f.id} className="rounded-xl bg-white border border-slate-200 p-4" data-testid={`fu-item-${f.id}`}>
            <div className="flex justify-between items-start">
              <div>
                <p className="font-semibold text-slate-800">{f.contact_name}</p>
                <p className="text-xs text-slate-500 flex items-center gap-1"><CalendarBlank size={13} /> {f.due_date} · {f.area}</p>
              </div>
              <span className="text-[10px] uppercase font-bold px-2 py-1 rounded-full bg-slate-100 text-slate-500">{f.contact_type}</span>
            </div>
            {tab !== "completed" && (
              <div className="flex gap-2 mt-3">
                <button onClick={() => complete(f.id)} data-testid={`fu-complete-${f.id}`} className="flex-1 min-h-[40px] rounded-lg bg-emerald-600 text-white text-sm font-semibold flex items-center justify-center gap-1"><CheckCircle size={16} /> {t("mark_complete")}</button>
                <button onClick={() => reschedule(f.id)} data-testid={`fu-reschedule-${f.id}`} className="min-h-[40px] px-3 rounded-lg border border-slate-200 text-sm">{t("reschedule")}</button>
                {f.gps && <a href={`https://maps.google.com/?q=${f.gps.lat},${f.gps.lng}`} target="_blank" rel="noreferrer" className="min-h-[40px] px-3 rounded-lg border border-slate-200 grid place-items-center"><MapPin size={16} /></a>}
              </div>
            )}
          </div>
        ))}
        {(data[tab] || []).length === 0 && <p className="text-center text-slate-400 py-10">{t("no_data")}</p>}
      </div>
    </Shell>
  );
}
